import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shoppingbag",
  "use": "shoppingbag-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"shoppingbag\"><g fill=\"none\" stroke=\"currentColor\" class=\"nc-icon-wrapper\"><path d=\"M5.945,55.2,12,18H52l6.055,37.2A5,5,0,0,1,53.12,61H10.88A5,5,0,0,1,5.945,55.2Z\" stroke-linecap=\"round\" stroke-width=\"2\" stroke-linejoin=\"round\" /><path d=\"M22,28V13A10,10,0,0,1,32,3h0A10,10,0,0,1,42,13V28\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol